module.exports = __webpack_public_path__ + "img/Imagotipo azul_b.d520ef7b.png";